var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed } from "mobx";
export class GlobalAdminManageOrganizationViewModel {
    get organizationId() {
        return this.adminUIManager.organizationIdToAdmin;
    }
    get organizationType() {
        return this.adminUIManager.organizationTypeToAdmin;
    }
    get editable() {
        return this.adminUIManager.organizationDetailsAreEditable;
    }
    get canCreateUser() {
        return this.adminUIManager.canCreateUserInOrganizationToShowUserDetailsFor;
    }
    constructor(container) {
        this.adminUIManager = container.globalAdminUIManager;
    }
    newUser() {
        this.adminUIManager.navigateToCreateUser();
    }
    viewUserDetails(userId) {
        this.adminUIManager.navigateToUserDetails(userId);
    }
}
__decorate([
    computed
], GlobalAdminManageOrganizationViewModel.prototype, "organizationId", null);
__decorate([
    computed
], GlobalAdminManageOrganizationViewModel.prototype, "organizationType", null);
__decorate([
    computed
], GlobalAdminManageOrganizationViewModel.prototype, "editable", null);
__decorate([
    computed
], GlobalAdminManageOrganizationViewModel.prototype, "canCreateUser", null);
